module.exports = __webpack_public_path__ + "img/sine-wave.9a5703d7.svg";